async function prepareDynamicJSFor(a, b, c, d) {
  if (
    (window.CJClientApi || (window.CJClientApi = {}),
    window.Shopify || (window.Shopify = {}),
    invokePartnerSnippets(
      d,
      Shopify.checkout,
      'undefined' === typeof cjShopifyData ? null : cjShopifyData
    ),
    !Shopify.checkout)
  ) {
    const { cjevent: a, cjdata: b } = getEventIdAndCJDataFromUrl();
    (a || b) && saveCJEventIdIntoCart(a, b),
      (window.CJClientApi.tagDataPromise = await getCJEventIdFromCart());
  } else if ('undefined' !== typeof cjShopifyData && cjShopifyData) {
    (window.cj = {}),
      (window.cj.order = {}),
      (shopifyCheckout = JSON.parse(JSON.stringify(Shopify.checkout)));
    const c = Shopify.checkout;
    (taxes_exclusion_required = cjShopifyData.taxes_exclusion_required),
      (taxToBeDivided =
        taxes_exclusion_required && c.tax_lines && 0 < c.tax_lines.length
          ? getTaxTobeDividedVal(c.tax_lines)
          : 1),
      (a = parseInt(`${a}`)),
      (isVariantIdReplaceSku =
        !!cjShopifyData.replace_sku_with_variant_id &&
        !0 == cjShopifyData.replace_sku_with_variant_id);
    const d = {
      enterpriseId: a,
      pageType: 'conversionConfirmation',
      cjPlugin: 'Shopify',
      userId: c.customer_id ? c.customer_id + '' : '',
      actionTrackerId: parseInt(`${b}`),
      currency: c.presentment_currency ? c.presentment_currency + '' : '',
      amount: c.subtotal_price ? getNumber(c.subtotal_price) : 0,
      coupon: c.discount ? getCoupon(c.discount) : '',
      taxAmount: c.total_tax ? c.total_tax : 0,
      customerCountry: c.shipping_address ? findCountryName(c.shipping_address) : '',
      items: c.line_items ? makeItemList(c.line_items) : '',
      discount: c.discount ? getDiscount(c.discount) : 0,
      shopifyOrderId: c.order_id ? c.order_id + '' : '',
    };
    if (cjShopifyData.ordersCount) {
      const a = cjShopifyData.ordersCount;
      d.customerStatus = '1' >= a ? 'New' : 'Return';
    }
    cjShopifyData.orderId && (d.orderId = cjShopifyData.orderId),
      cjShopifyData.items && setDiscountAndUnitPrice(d, cjShopifyData),
      cjShopifyData.taxes_exclusion_required && (d.amount = getTaxFreeAmount()),
      isShippingDiscount(c) && (d.discount = 0);
    const e = {
      enterpriseId: d.enterpriseId,
      pageType: d.pageType,
      userId: d.userId,
      cartSubtotal: d.amount,
      items: d.items,
    };
    (window.cj.order = cleanObject(d)), (window.cj.sitePage = cleanObject(e));
  } else console.log('cjShopifyData not found');
  const e = document.createElement('script');
  (e.src = `https://www.mczbf.com/tags/${c}/tag.js`),
    (e.type = 'text/javascript'),
    (e.async = !0),
    (e.id = 'cjapitag'),
    document.head.appendChild(e);
}
var sumOfItemLevelUnitPrice,
  totalAmountCalculated = 0;
let taxes_exclusion_required = !1,
  taxToBeDivided = 1,
  totalItemLevelDiscountWithoutTax = 0,
  totalDiscount = 0,
  isVariantIdReplaceSku = !1,
  shopifyCheckout = {};
function setDiscountAndUnitPrice(a, b) {
  (null == a.discount || 0 == a.discount) && (a.discount = 0), (sumOfItemLevelUnitPrice = 0);
  let c = 0,
    d = !0,
    e = transformItemList(b.items);
  a.items = isVariantIdReplaceSku ? replaceSkuWithVariantId(e) : e;
  let f = (function (a) {
    for (let b in a) if (0 === a[b].unitPrice && 0 < a[b].discount) return !0;
    return !1;
  })(a.items);
  for (let d of b.items) (sumOfItemLevelUnitPrice += d.unitPrice * d.quantity), (c += d.discount);
  sumOfItemLevelUnitPrice = parseFloat(sumOfItemLevelUnitPrice.toFixed(2));
  let g = !0 >= c;
  if (
    (!0 == g
      ? ((totalAmountCalculated = getAmountPostDiscount(a.discount, sumOfItemLevelUnitPrice, c)),
        taxes_exclusion_required
          ? ((a.items = a.items.map((a) => ({
              ...a,
              discount: reCalculateDiscountPrice(a.discount),
            }))),
            (totalItemLevelDiscountWithoutTax = a.items.reduce((a, b) => a + +b.discount, 0)),
            (totalItemLevelDiscountWithoutTax = parseFloat(
              totalItemLevelDiscountWithoutTax
            ).toFixed(2)),
            (d = !0))
          : sumOfItemLevelUnitPrice > a.amount &&
            sumOfItemLevelUnitPrice === parseFloat((c + a.amount).toFixed(2))
          ? (d = !0)
          : sumOfItemLevelUnitPrice > a.amount && 0 !== a.discount
          ? totalAmountCalculated == a.amount
            ? (d = !0)
            : (d = !1)
          : sumOfItemLevelUnitPrice === a.amount && (d = !1))
      : (d = !0),
    !1 === d)
  )
    a.items = a.items.map((a) => ({
      ...a,
      unitPrice: getFixedUnitPrice(a.unitPrice, a.discount, a.quantity),
    }));
  else if (taxes_exclusion_required) {
    let b = reCalculateDiscountPrice(a.discount);
    if (totalItemLevelDiscountWithoutTax == b)
      (a.discount = 0), (totalDiscount = totalItemLevelDiscountWithoutTax);
    else if (g && totalItemLevelDiscountWithoutTax != b) {
      let c = (b - totalItemLevelDiscountWithoutTax).toFixed(2),
        d = 0;
      if (f) {
        a.items = a.items.map((a) => ({
          ...a,
          unitPrice:
            0 === a.unitPrice
              ? parseFloat(getFixedUnitPrice(a.unitPrice, a.discount, a.quantity))
              : a.unitPrice,
        }));
        for (let b of a.items) b.unitPrice == b.discount && (d += parseFloat(b.discount));
        c = parseFloat(c) + d;
      }
      (a.discount = parseFloat(c).toFixed(2)), (totalDiscount = b);
    } else (totalDiscount = b), (a.discount = totalDiscount);
  } else
    totalAmountCalculated != a.amount &&
      (a.discount = 0 === a.discount ? 0 : a.discount.toFixed(2) - c.toFixed(2));
}
function replaceSkuWithVariantId(a) {
  return a.map((a) => {
    let b = shopifyCheckout.line_items.find((b) => handlelize(b.sku) == a.itemId);
    return {
      ...a,
      itemId: b.variant_id,
    };
  });
}
function reCalculateDiscountPrice(a) {
  return a ? parseFloat(a / taxToBeDivided).toFixed(2) : parseFloat(a).toFixed(2);
}
function getTaxTobeDividedVal(a) {
  let b = a.reduce((a, b) => a + +b.rate, 1);
  return parseFloat(b).toFixed(2);
}
function getAmountPostDiscount(a, b, c) {
  var d = 0,
    e = b - (a + c);
  return (e = e.toFixed(2)), (d = parseFloat(e)), d;
}
function getDiscount(a) {
  return a.amount ? getNumber(a.amount) : 0;
}
function getCoupon(a) {
  return a.code ? a.code : '';
}
function isShippingDiscount(a) {
  let b = getNumber(a.total_tax);
  a.taxes_included && (b = 0);
  const c = getNumber(a.total_price),
    d = getNumber(a.subtotal_price);
  let e = 0;
  a.shipping_rate && (e = getNumber(a.shipping_rate.price));
  const f = c - b - d;
  let g = !0;
  if (0 != e && 0.01 > f.toFixed(2) - e.toFixed(2)) {
    let b = sumOfItemLevelUnitPrice;
    a.discount != null && (b -= getNumber(a.discount.amount)), b >= d && (g = !1);
  }
  return 0 != e && f.toFixed(2) < e.toFixed(2) && g;
}
function getOrderLevelDiscount(a) {
  let b = 0;
  return a && (b = a.map((a) => getNumber(a.discount)).reduce((a, b) => a + b)), b;
}
function trimSpace(a) {
  return a.trim();
}
function transformItemList(a) {
  return a.map((a) => ({
    ...a,
    itemId: trimSpace(a.itemId),
    unitPrice: +parseFloat(a.unitPrice).toFixed(2),
  }));
}
function makeItemList(a) {
  if (a) {
    return a.map((a) => ({
      itemId: isVariantIdReplaceSku ? a.variant_id : a.sku ? trimSpace(a.sku) : '',
      unitPrice: a.price ? getNumber(a.price) : 0,
      quantity: a.quantity ? getNumber(a.quantity) : 0,
      discount: '',
    }));
  }
  return [];
}
function findCountryName(a) {
  return a ? (a.country_code ? a.country_code : '') : '';
}
function getEventIdAndCJDataFromUrl() {
  const a = window.location.search,
    b = new URLSearchParams(a),
    c = b.get('cjevent'),
    d = b.get('cjData');
  return {
    cjevent: c,
    cjdata: d,
  };
}

function waitForRoutes() {
  return new Promise((resolve) => {
    if (window && window?.routes && window?.routes?.cart_url) {
      return resolve();
    }

    const interval = setInterval(() => {
      if (window && window?.routes && window?.routes?.cart_url) {
        clearInterval(interval);
        resolve();
      }
    }, 50);

    setTimeout(() => {
      clearInterval(interval);
      resolve();
    }, 4000);
  });
}

async function getCJEventIdFromCart() {
  // Pause execution here until waitForRoutes() resolves
  await waitForRoutes();

  if (window?.routes?.cart_url) {
    return fetch(window.routes.cart_url + '.js')
      .then((a) => a.json())
      .then(({ attributes: a = {} }) => {
        const { cjevent: b, cjdata: c } = a;
        return {
          cjevent: b,
          cjdata: c,
        };
      })
      .catch(() => ({}));
  }
}
async function saveCJEventIdIntoCart(a, b) {
  try {
    const c = new FormData();
    a && c.append('attributes[cjevent]', a), b && c.append('attributes[cjdata]', b);
    const d = await fetch(window.routes.cart_update_url + '.js', {
        body: c,
        method: 'post',
      }),
      e = await d.json();
    (e.attributes == null || e.attributes.cjevent == null) &&
      console.log('Unexpected error occurred in saving cart attribute');
  } catch (a) {
    console.log('Unexpected error occurred in saving cart attribute');
  }
}
function cleanObject(a) {
  return a.items && removeItemDiscountWithValueZero(a.items), getDefinedProps(a);
}
function removeItemDiscountWithValueZero(a) {
  a.forEach((a) => {
    for (let b in a) (value = a[b]), 'discount' == b && 0 === value && delete a[b];
  });
}
function isArray(a) {
  return '[object Array]' === Object.prototype.toString.call(a);
}
function getDefinedProps(a) {
  for (let b in a)
    (value = a[b]),
      ('' === value || null === value || void 0 === value) && 'itemId' !== b
        ? delete a[b]
        : isArray(value) &&
          value.forEach((a) => {
            getDefinedProps(a);
          });
  return a;
}
function getNumber(a) {
  return isNaN(a) ? 0 : +a;
}
function getFixedUnitPrice(a, b, c) {
  return parseFloat(a + b / c).toFixed(2);
}
function handlelize(a) {
  return (
    (a = a
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase()),
    a
  );
}
function getTaxFreeAmount() {
  return parseFloat(sumOfItemLevelUnitPrice - totalDiscount).toFixed(2);
}
function invokePartnerSnippets(a, b, c) {
  a = 'object' === typeof a ? {} : JSON.parse(a);
  try {
    if (a.revlifterUUID) {
      const b = 'https://assets.revlifter.io/' + a.revlifterUUID + '.js';
      revlifterSnippet(window, document, 'script', b, 'revlifter');
    }
  } catch (a) {
    console.error('invokePartnerSnippets - revlifterSnippet ' + a);
  }
  try {
    a.yieldifyUUID && yieldifySnippets(a.yieldifyUUID);
  } catch (a) {
    console.error('invokePartnerSnippets - yieldifySnippets - exception' + a);
  }
  try {
    if (a.upSellitUUID && (upSellitGlobalSnippet(a.upSellitUUID), b && c)) {
      const d = b.subtotal_price ? getNumber(b.subtotal_price) : 0,
        e = b.presentment_currency ? b.presentment_currency + '' : '';
      upSellitSalePixel(a.upSellitUUID, c.orderId, d, e);
    }
  } catch (a) {
    console.log('invokePartnerSnippets - UpSellit Snippets - exception' + a);
  }
}
async function revlifterSnippet(b, c, d, e, f, g, h) {
  (b.RevLifterObject = f),
    (b[f] =
      b[f] ||
      function () {
        (b[f].q = b[f].q || []).push(arguments);
      }),
    (b[f].l = 1 * new Date());
  try {
    (g = c.createElement(d)),
      (h = c.getElementsByTagName(d)[0]),
      (g.async = 1),
      (g.src = e),
      h.parentNode.insertBefore(g, h);
  } catch (a) {
    console.error('revlifterSnippet exception ' + a);
  }
}
function yieldifySnippets(a) {
  yieldifyPageLoadSnippet(a);
  yieldifyIntegrationTag(
    window,
    document,
    'https://td.yieldify.com/yieldify/code.js?w_uuid=' + a + '&k=1'
  );
}
function yieldifyPageLoadSnippet(a) {
  try {
    let b = document.createElement('script');
    (b.src =
      'https://td.yieldify.com/yieldify/code.js?w_uuid=' + a + '&k=1&loca=' + window.location.href),
      (b.async = !0),
      document.getElementsByTagName('head')[0].appendChild(b);
  } catch (a) {
    console.error('yieldifyPageLoadSnippet exception ' + a);
  }
}
function yieldifyIntegrationTag(b, d, e) {
  try {
    var f = ['scroll', 'mousedown', 'mousemove', 'click', 'keydown', 'touchstart'],
      c = function () {
        var a = d.createElement('script');
        (a.src = e + '&loca=' + b.location.href),
          (a.async = !0),
          d.getElementsByTagName('head')[0].appendChild(a);
      };
    if (/_yi=/.test(d.cookie)) c();
    else {
      var g = function (a, c) {
          a.forEach(function (a) {
            return b.removeEventListener(a, c);
          });
        },
        h = function (a) {
          if (!a || a.isTrusted)
            try {
              c(), g(f, h);
            } catch (a) {}
        };
      f.forEach(function (a) {
        return b.addEventListener(a, h);
      });
    }
  } catch (a) {
    console.error('yieldifyIntegrationTag exception ' + a);
  }
}
async function upSellitGlobalSnippet(a) {
  try {
    (usi_installed = 0),
      (USI_installCode = function () {
        if (0 == usi_installed) {
          usi_installed = 1;
          var b = document.getElementsByTagName('head')[0],
            c = document.createElement('script');
          (c.type = 'text/javascript'),
            (c.src = '//www.upsellit.com/active/' + a + '.jsp'),
            b.appendChild(c);
        }
      }),
      'undefined' !== typeof document.readyState && 'complete' === document.readyState
        ? USI_installCode()
        : window.addEventListener
        ? window.addEventListener('load', USI_installCode, !0)
        : window.attachEvent
        ? window.attachEvent('onload', USI_installCode)
        : USI_installCode(),
      setTimeout('USI_installCode()', 1e4);
  } catch (a) {
    console.error('upSellitGlobalSnippet exception ' + a);
  }
}
function upSellitSalePixel(a) {
  try {
    var b = document.getElementsByTagName('head')[0],
      c = document.createElement('script');
    c.setAttribute('type', 'text/javascript'),
      (c.src = 'https://www.upsellit.com/active/' + a + '_pixel.jsp'),
      b.appendChild(c);
  } catch (a) {
    console.error('upSellitSalePixel exception ' + a);
  }
}
prepareDynamicJSFor(1566839, 441302, 596241226179, '{}');
